<template>
  <div class="layout">
      <Layout>
        <Header class="main-header" style="padding: 0; background-color: #ffffff; box-shadow: 1px 0 6px 0 rgba(39, 54, 78, 0.12); line-height: 50px; height: 50px">
          <Menu mode="horizontal" theme="light" active-name="1" style="color: #162D3D; padding: 0 12px;height: 50px; line-height: 50px">
            <div class="layout-logo">
              <div style="font-size: 16px; font-weight: 500; margin: 0 16px 0 10px">
                <img src="../../assets/logo_new.png" style="height: 34px; vertical-align: middle; margin-right: 8px" />
                <router-link :to="{name: 'meeting-list',  query: { t: + new Date() }}" style="color:#162D3D">经贸活动云</router-link></div>
            </div>
            <div class="header-avator-con">
              <!--<full-screen v-model="isFullScreen" @on-change="fullscreenChange"></full-screen>-->
              <!--<lock-screen></lock-screen>-->
              <!--<message-tip v-model="mesCount"></message-tip>-->
              <!--<theme-switch></theme-switch>-->
              <!--<div>-->
                <!--<a href="/api/admin/meetings/file/download?path=doc/bizevent_instructions.docx&fileName=活动云管理系统使用说明.docx">-->
                  <!--<Icon type="ios-cloud-download-outline" size="16"/>下载系统使用说明书-->
                <!--</a>-->
              <!--</div>-->
              <div class="user-dropdown-menu-con">
                <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
                  <Col>
                    <a href="/api/admin/meetings/file/download?path=doc/bizevent_instructions.docx&fileName=活动云管理系统使用说明.docx" style="color: #162D3D" >
                    <Icon type="ios-cloud-download-outline" size="20"/>下载系统说明书
                    </a>
                  </Col>
                  <Col offset="2">
                    <Dropdown transfer trigger="click" @on-click="handleClickUserDropdown">
                      <a style="color: #162D3D" href="javascript:void(0)">
                        <span class="main-user-name">{{ userName }}</span>
                        <Icon type="md-arrow-dropdown"></Icon>
                      </a>
                      <DropdownMenu slot="list">
                        <DropdownItem name="modifyPwd">修改密码</DropdownItem>
                        <DropdownItem name="loginout" divided>退出登录</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                    <Avatar icon="ios-person" style="background-color: #f56a00; margin-left: 10px;"/>
                  </Col>

                </Row>
              </div>
            </div>
          </Menu>
        </Header>
        <Layout>
          <Sider hide-trigger :style="{background: '#fff'}" class="sidebar-menu-con">
            <main-nav></main-nav>
          </Sider>
          <Layout class="main-content">
            <Content>
              <div class="wrapper-content ">
                <router-view/>
              </div>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </div>
</template>
<script>
import MainNav from './MainNav.vue'
import * as types from '../../store/mutation-types'

export default {
  name: 'Main',
  components: {
    MainNav
  },

  computed: {
    userName () {
      return this.$store.state.user.nickname
    }
  },
  methods: {
    handleClickUserDropdown (name) {
      if (name === 'loginout') {
        // 退出登录
        this.$store.commit(types.SET_TOKEN, null)
        this.$router.push({
          name: 'login'
        })
      } else if (name === 'modifyPwd') {
        // 修改密码
        this.$router.push({
          name: 'modify-pwd'
        })
      }
    }
  }
}
</script>
<style>
.ivu-breadcrumb {
  padding: 10px 20px;
}
.ivu-menu-submenu-title {
  font-weight: 500;
}
.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item {
  padding-left: 49px !important;
}
</style>

<style scoped lang="scss">
  .layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: scroll;
  }
  .main-header {
    position: fixed;
    z-index: 11;
    top: 0;
    left: 0;
    width: 100%;

    .main-user-name {
      font-size: 12px;
      padding-right: 5px;
    }
  }
  .sidebar-menu-con {
    position: fixed;
    z-index: 10;
    top: 54px;
    left: 0;
    bottom: 0;
    width: 100%;
  }
  .main-content {
    margin-left: 200px;
    margin-top: 64px;
  }
  .layout-logo{
    /*width: 150px;*/
    /*height: 30px;*/
    /*background: #5b6270;*/
    /*border-radius: 3px;*/
    float: left;
    /*position: relative;*/
    /*top: 15px;*/
    /*left: 20px;*/
    color: white;

  }
  .layout-nav{
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/Main.vue